
const BASE_URL="https://bikreta.onrender.com";
export default BASE_URL;
